import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { ButtonsSection } from "./FormActionButtons.css";

interface FormActionButtonsProps {
  onBack: () => void;
  disableBackButton?: boolean;
  displayNextButton?: boolean;
  submitButtonType?: "submit" | "button";
  leftButtonName?: string;
  rightButtonName?: string;
  onButtonTypeClick?: () => void;
  disableNextButton?: boolean;
}

export const FormActionButtons = ({
  onBack,
  disableBackButton,
  displayNextButton = true,
  submitButtonType = "submit",
  onButtonTypeClick,
  leftButtonName,
  rightButtonName,
  disableNextButton,
}: FormActionButtonsProps) => {
  const { t } = useTranslation();

  return (
    <ButtonsSection>
      <Button
        onClick={() => onBack()}
        disabled={disableBackButton}
        size={"large"}
      >
        {t(leftButtonName ?? "back")}
      </Button>
      {displayNextButton && (
        <Button
          {...(submitButtonType === "button" && { onClick: onButtonTypeClick })}
          type={submitButtonType}
          size={"large"}
          disabled={disableNextButton}
          variant={"contained"}
        >
          {t(rightButtonName ?? "next")}
        </Button>
      )}
    </ButtonsSection>
  );
};
